
import Icon from '../../components/bases/icone/icon';

import AppBase from '../appBase';
import ToolsBar from '../../components/bases/toolsbar/toolsbar';

import User from "./appcomponents/user/user.js"
import ProjectsFilter from './appcomponents/projectfilters/projectfilters.js';
import ProjectsList from './appcomponents/projectslist/projectslist.js';
import AppHeader from './appcomponents/appheader/appheader.js';
import SelectLanguage from '../../components/bases/selectlanguage/selectlanguage.js';

import AddVideo from '../dialogs/addvideo/addvideo.js';
import ClientsDiffusorsList from './tables/clientsdiffusors/clientsdiffusorslist.js';
import SeriesList from './tables/series/serieslist.js';
import UsersList from './tables/users/users.js';


import { GlobalProvider, UploadComponentRef} from "../../utils/globalprovider.js";
import {getCurrentUserDatas} from "../../utils/software.js"


import styles from "../appstyles/styles.module.css"
import "../appstyles/local.css"


import ftva from "../../assets/ftva.png"
import easytt from "../../assets/logoEasyTTSmall.png"

import imgaddvideo from "./assets/toolsbar/videoplus.png"

import imgclients from "./tables/assets/clients.png"
import imgdiffuseurs from "./tables/assets/diffuseurs.png"
import imgseries from "./tables/assets/series.png"
import imgconfig from "./tables/assets/configurations.png"
import imgusers from "./tables/assets/users.png"

import { getCurrentProjectDatas } from '../../utils/software.js';

import React from "react";



class AppLocal extends AppBase
{

    constructor (props)
    {
        super(props);
        
        const superuser = (getCurrentUserDatas().droits === 4);
        const bestuser = (getCurrentUserDatas().droits !== 1);


        var pjid = getCurrentProjectDatas().pjid;


        this.state = {

          displayAddVideo: false,
          displayDialogClients: false, 
          displaySeries: false,
          displayUsers: false,
          keyboardenable:true,
          pjidcurrent: pjid,
          
          

          table: "",


          toolsbar:
          { 
            height: 20,

            items: [
              {type:"space"},
              {img: imgaddvideo ,type:"button", disable:!bestuser,fr:"Ajouter une vidéo",en:"Add video file", nochangecolor:false, key:{key:"ADDVIDEO", cat:"applocalshortcut"}},
              {type:"bigspace"},
              {img: imgclients ,type:"button", disable:!bestuser,fr:"Clients...",en:"Clients...", nochangecolor:false, key:{key:"CLIENTS", cat:"applocalshortcut"}},
              {img: imgdiffuseurs ,type:"button", disable:!bestuser,fr:"Diffuseurs...",en:"Diffusors...", nochangecolor:false, key:{key:"DIFFUSEURS", cat:"applocalshortcut"}},
              {img: imgseries ,type:"button", disable:!bestuser,fr:"Series...",en:"Series...", nochangecolor:false, key:{key:"SERIES", cat:"applocalshortcut"}},
              {img: imgconfig ,type:"button", disable:!bestuser,fr:"Configurations...",en:"Settings...", nochangecolor:false, key:{key:"CONF", cat:"applocalshortcut"}},
            ],
          }

        }

        this.projectsFilterRef = React.createRef();
        this.projectsListRef = React.createRef();
        this.appHeaderRef = React.createRef();




        this.onClickToolsBar = this.onClickToolsBar.bind(this);
        this.OnAddVideoButton = this.OnAddVideoButton.bind(this);
        this.onValidFormClientsDiffs = this.onValidFormClientsDiffs.bind(this);
        this.onValidFormSeries = this.onValidFormSeries.bind(this);
        this.onValidFormUsers = this.onValidFormUsers.bind(this);
        this.onNewProjectFilters = this.onNewProjectFilters.bind(this);
        this.onSelectProject = this.onSelectProject.bind(this);
        this.onCheckSelectProjet = this.onCheckSelectProjet.bind(this);
        this.oncloseprojectheader = this.oncloseprojectheader.bind(this);
        this.onkeydownonlist = this.onkeydownonlist.bind(this);
        this.ondisablekeyboard = this.ondisablekeyboard.bind(this);

  
    }  

    ondisablekeyboard(disable)
    {
        
        this.setState({keyboardenable: !disable});
    }  

    onkeydownonlist(event)
    {
      if (this.state.keyboardenable)
      {
        if ((event.key==="ArrowDown" && !event.altKey && !event.ctrlKey && !event.shiftKey))
        {
          if ((this.projectsListRef) && (this.projectsListRef.current))
            this.projectsListRef.current.nextProject();
        }
        if ((event.key==="ArrowUp" && !event.altKey && !event.ctrlKey && !event.shiftKey))
        {
          if ((this.projectsListRef) && (this.projectsListRef.current))
            this.projectsListRef.current.previousProject();
        }
        }
        if ((event.key==="Enter" && !event.altKey && !event.ctrlKey && !event.shiftKey))
        {
          if ((this.projectsListRef) && (this.projectsListRef.current))
            this.projectsListRef.current.selectProject();
        }
  
    }

    onSelectProject(pjid)
    {
      this.appHeaderRef.current.setNewProject(pjid);
      this.setState({pjidcurrent: pjid});
    }

    oncloseprojectheader()
    {
      this.setState({pjidcurrent: 0});
    }

    onCheckSelectProjet(pjid)
    {
      this.appHeaderRef.current.checkProject(pjid);
    }


    OnAddVideoButton(button, formulaire)
    {
      console.log("retour addvideo", button, formulaire)
      this.setState({displayAddVideo: false, keyboardenable:true});
      if (button === "ok")
        UploadComponentRef.current.addUpload(0, formulaire);
    }


    onNewProjectFilters(filters)
    {
      this.projectsListRef.current.setDatasSearchDatas(filters);
      console.log(filters)

    }


    canClose()
    {
      return true;
      
    }
    
    
    componentDidMount() {
        var formulaire = this.projectsFilterRef.current.GetDatasSearchDatas();
        this.projectsListRef.current.setDatasSearchDatas(formulaire);
        window.addEventListener('keydown', this.onkeydownonlist);
    }
  



    // Suppression de l'écouteur lorsque le composant est démonté
    componentWillUnmount() 
    {
      window.removeEventListener('keydown', this.onkeydownonlist);
    }  
      


  onClickToolsBar(datas)
  {
    
    switch (datas.cat)
    {
      case "applocalshortcut":
        switch (datas.key)
        {
          case "ADDVIDEO":
            this.setState({displayAddVideo: true, keyboardenable:false})
            break;
          case "CLIENTS":
          case "DIFFUSEURS":
            this.setState({displayDialogClients: true, table: datas.key, keyboardenable:false});
            break;
          case "SERIES":
            this.setState({displaySeries: true, table: "", keyboardenable:false});
            break;
          case "USERS":
            this.setState({displayUsers: true, table: "", keyboardenable:false});
            break;
        }
        
    }
  }

  refreshProjectList()
{
  var formulaire = this.projectsFilterRef.current.GetDatasSearchDatas();
  this.projectsListRef.current.setDatasSearchDatas(formulaire);  
}


  onValidFormClientsDiffs(ret)
  {
      this.setState({displayDialogClients: false, keyboardenable:true})
      this.refreshProjectList();

  }

  onValidFormSeries(ret)
  {
      this.setState({displaySeries: false, keyboardenable:true})
      this.refreshProjectList();
  }

  onValidFormUsers(ret)
  {
      this.setState({displayUsers: false, keyboardenable:true})
      this.refreshProjectList();
  }
  
  render ()
  {
    

    const title = this.context.language=="fr"?"MES PROJETS":"MY PROJECTS"
    
    var addvideo = []
    if (this.state.displayAddVideo)
      addvideo.push(<AddVideo display = {this.state.displayAddVideo} onButton ={this.OnAddVideoButton}/>)
   
    if (this.state.displayDialogClients)
      addvideo.push(<ClientsDiffusorsList current={0} onvalidform={this.onValidFormClientsDiffs} closebutton = {true} zindex={1} display = {this.state.displayDialogClients} table={this.state.table} select={false}/>)

    if (this.state.displaySeries)
      addvideo.push(<SeriesList onvalidform={this.onValidFormSeries} closebutton = {true} zindex={1} display = {this.state.displaySeries} select={false} />)

    if (this.state.displayUsers)
      addvideo.push(<UsersList onvalidform={this.onValidFormUsers} closebutton = {true} zindex={1} display = {this.state.displayUsers} select={false} />)

  
    return (
      <>
      <div className={styles.appDiv}>
        <div className={styles.appDivTop}>
          <div className={styles.appDivLogoFtva}>
              <img src={ftva} style = {{width:"100%", verticalAlign:"middle"}}/>
          </div>
          <div className={styles.appDivProject}>
              <div className={styles.appDivProjectLeft}>
              <h1>{title}</h1>
              </div>
              <div className={styles.appDivProjectRight}>
              <AppHeader ref={this.appHeaderRef} oncloseproject = {this.oncloseprojectheader} canclose={true}/>
              </div>

          </div>
          <div className={styles.appDivLogo}>
          <Icon image={easytt} height="100%" width="100%"/>
          </div>
          <div className={styles.appDivLanguage}>
             <SelectLanguage/>
          </div>
          <div className={styles.appDivUser}>
              <User onnavigate = {this.props.onnavigate} onCancelKeyboardEvent={this.onCancelKeyboardEvent}/>
          </div>
        </div>
        <div className={styles.appDivToolsBar}>
            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar}/>
        </div>
        <div className={styles.appDivBody} ref = {this.bodyDivRef}>
      <div className={styles.appPanelsContainerRow}>


              <div className='appLocalLeft'>
              <ProjectsFilter ref = {this.projectsFilterRef} onNewSearch = {this.onNewProjectFilters} />
              </div>
              <div className='appLocalRight'>
              <ProjectsList ref = {this.projectsListRef} 
                onSelectProject ={this.onSelectProject}
                onCheckSelectProjet = {this.onCheckSelectProjet}
                pjidcurrent = {this.state.pjidcurrent}
                ondisablekeyboard = {this.ondisablekeyboard}
                />
              </div>
          </div>
              
          
          </div>
          
      </div>
      {addvideo}
      </>
    
    )
    }
}


export default AppLocal;
